import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React from 'react';
import { cx, css } from 'emotion';
import styled from '@emotion/styled';
import PCSlider from '../../pc/Question/MaterialUI/Slider';
import MobileSlider from '../../mobile/Question/MaterialUI/Slider';
import IconFont from '@/components/common/IconFont';
import emojiImg1 from '@/images/emoji-1.png';
import emojiImg2 from '@/images/emoji-2.png';
import emojiImg3 from '@/images/emoji-3.png';
import emojiImg4 from '@/images/emoji-4.png';
import emojiImg5 from '@/images/emoji-5.png';
import emojiGrayImg1 from '@/images/emoji-1-gray.png';
import emojiGrayImg2 from '@/images/emoji-2-gray.png';
import emojiGrayImg3 from '@/images/emoji-3-gray.png';
import emojiGrayImg4 from '@/images/emoji-4-gray.png';
import emojiGrayImg5 from '@/images/emoji-5-gray.png';
export default function NewScale(props) {
  var marks = props.marks,
    onChange = props.onChange,
    selected = props.selected,
    min = props.min,
    max = props.max,
    styleType = props.styleType,
    question = props.question,
    _props$descriptionTyp = props.descriptionType,
    descriptionType = _props$descriptionTyp === void 0 ? 'top' : _props$descriptionTyp,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$device = props.device,
    device = _props$device === void 0 ? 'pc' : _props$device;
  var maxNum = max.num;
  var minNum = min.num;
  var marksStyle = styleType === 'slider' ? {
    position: 'relative',
    width: device === 'pc' ? '82%' : '86%',
    marginLeft: device === 'pc' ? '9%' : '7%',
    overflow: 'inherit'
  } : {};
  return React.createElement(ScaleBox, {
    style: style
  }, React.createElement("div", {
    className: "flex overflowHidden justifyAround topMarks",
    style: _objectSpread({
      margin: '0 0 12px'
    }, marksStyle)
  }, Object.keys(marks).sort(function (a, b) {
    return a - b;
  }).map(function (key, i) {
    var flex = '1 1 10%';
    var textAlign = 'center';
    var alignItems = 'center';
    if (marks[key]) {
      return React.createElement(React.Fragment, null, React.createElement(Labels, {
        key: key,
        onClick: function onClick() {
          return onChange(key);
        },
        style: {
          flex: flex,
          textAlign: textAlign,
          wordWrap: 'word-break',
          alignItems: alignItems,
          position: styleType === 'slider' && 'absolute',
          left: styleType === 'slider' && "".concat(100 / (maxNum - minNum) * i, "%"),
          transform: styleType === 'slider' && 'translateX(-50%)',
          width: styleType === 'slider' && "".concat(100 / (maxNum - minNum + 1), "%"),
          color: styleType === 'slider' && Number(selected) >= Number(key) && 'var(--primary-color)'
        },
        className: "flex1 columnFlex justifyBetween pointer no-touch"
      }, descriptionType === 'top' ? marks[key] : key || ''), styleType === 'slider' && React.createElement(Labels, {
        key: key + i,
        style: {
          flex: flex,
          textAlign: textAlign,
          wordWrap: 'word-break',
          alignItems: alignItems,
          opacity: 0,
          width: 0
        },
        className: "flex1 columnFlex justifyBetween pointer no-touch"
      }, descriptionType === 'top' ? marks[key] : key || ''));
    }
    return React.createElement("div", {
      key: key,
      className: "flex1",
      style: {
        margin: 0,
        flex: flex
      }
    });
  })), styleType === 'point' && React.createElement(Points, {
    selected: selected,
    onChange: onChange,
    marks: marks
  }), styleType === 'nps' && React.createElement(Nps, {
    selected: selected,
    onChange: onChange,
    marks: marks,
    device: device
  }), styleType === 'emoji' && React.createElement(Emoji, {
    selected: selected,
    onChange: onChange,
    marks: marks,
    device: device
  }), styleType === 'star' && React.createElement(Points, {
    selected: selected,
    onChange: onChange,
    marks: marks,
    styleType: "star"
  }), styleType === 'slider' && (device === 'pc' ? React.createElement(PCSlider, {
    selected: selected,
    onChange: onChange,
    marks: marks,
    min: min.num,
    max: max.num,
    id: question.id,
    marksTop: descriptionType === 'top'
  }) : React.createElement(MobileSlider, {
    selected: selected,
    onChange: onChange,
    marks: marks,
    min: min.num,
    max: max.num,
    id: question.id,
    marksTop: descriptionType === 'top'
  })), descriptionType === 'down' && React.createElement("div", {
    className: "bottomMarks"
  }, Object.keys(marks).filter(function (key) {
    return !!marks[key];
  }).sort(function (a, b) {
    return a - b;
  }).map(function (key) {
    return React.createElement("div", {
      key: key,
      className: "flex alignCenter"
    }, React.createElement("div", {
      className: "number"
    }, key), React.createElement("span", null, marks[key]));
  })));
}
export function Nps(props) {
  var marks = props.marks,
    selected = props.selected,
    onChange = props.onChange,
    device = props.device;
  return React.createElement(NpsSquare, {
    device: device
  }, Object.keys(marks).sort(function (a, b) {
    return a - b;
  }).map(function (key, i) {
    return React.createElement("div", {
      key: key,
      className: cx(Number(selected) >= Number(key) && 'selected', 'number'),
      onClick: function onClick() {
        return onChange(key);
      }
    }, React.createElement("div", {
      className: "nps-item"
    }, i), React.createElement("div", {
      className: "number-tips"
    }));
  }));
}
export function Emoji(props) {
  var marks = props.marks,
    selected = props.selected,
    onChange = props.onChange,
    device = props.device;
  var emojiOptions = {
    1: emojiImg1,
    2: emojiImg2,
    3: emojiImg3,
    4: emojiImg4,
    5: emojiImg5
  };
  var emojiGrayOptions = {
    1: emojiGrayImg1,
    2: emojiGrayImg2,
    3: emojiGrayImg3,
    4: emojiGrayImg4,
    5: emojiGrayImg5
  };
  return React.createElement("div", {
    className: emojiRateCls
  }, React.createElement("div", {
    className: "emoji-rate-faces"
  }, Object.keys(marks).sort(function (a, b) {
    return a - b;
  }).map(function (key, i) {
    return React.createElement("div", {
      key: key,
      className: "emoji-rate-face",
      onClick: function onClick() {
        return onChange(key);
      }
    }, React.createElement("img", {
      src: emojiOptions[i + 1],
      style: {
        opacity: String(selected) === String(key) ? 1 : 0,
        position: 'absolute',
        // top: device === 'mobile' ? 0 : '5px',
        top: 0,
        left: 0
      }
    }), React.createElement("img", {
      src: emojiGrayOptions[i + 1],
      style: {
        opacity: String(selected) === String(key) ? 0 : 1
      }
    }));
  })));
}
export function Points(props) {
  // Points的selected是option id
  var marks = props.marks,
    selected = props.selected,
    onChange = props.onChange,
    _props$styleType = props.styleType,
    styleType = _props$styleType === void 0 ? 'square' : _props$styleType,
    _props$isScaleMatrix = props.isScaleMatrix,
    isScaleMatrix = _props$isScaleMatrix === void 0 ? false : _props$isScaleMatrix;
  return React.createElement("div", {
    className: "flex justifyAround "
  }, Object.keys(marks).map(function (key, i) {
    var starTo = Object.keys(marks).findIndex(function (el) {
      return el === selected;
    });
    return React.createElement(Circle, {
      className: cx(selected === key && 'selected', styleType),
      key: key,
      onClick: function onClick() {
        return onChange(key);
      }
    }, React.createElement("div", null, styleType === 'square' && (isScaleMatrix ? i + 1 : key), styleType === 'star' && React.createElement(React.Fragment, null, React.createElement(IconFont, {
      className: "anticon-star",
      type: "icon-starmarkhighligh",
      style: {
        fontSize: 20,
        position: 'absolute',
        opacity: +(starTo >= i)
      },
      color: "orange"
    }), React.createElement(IconFont, {
      className: "anticon-star",
      type: "icon-star",
      style: {
        fontSize: 20,
        position: 'absolute',
        opacity: +(starTo < i)
      },
      color: "orange"
    }))));
  }));
}
var ScaleBox = /*#__PURE__*/styled("div", {
  target: "e1pdnymx0"
})("width:100%;margin-left:0px;margin-right:0px;.topMarks{font-size:13px;font-weight:500;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color);.labelPoint{width:4px;height:4px;border-radius:50%;background-color:var(--text-color-secondary);}}.bottomMarks{margin-top:32px;font-size:0.9rem;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color-secondary);.number{width:15px;margin-right:8px;}& > div{margin-bottom:12px;}& > div:last-child{margin-bottom:0;}}");
var Circle = /*#__PURE__*/styled("div", {
  target: "e1pdnymx1"
})("height:48px;flex:1;display:flex;justify-content:center;align-items:center;line-height:1.5;div{height:100%;width:100%;margin:2px;cursor:pointer;border-radius:2px;display:flex;justify-content:center;align-items:center;font-size:1rem;}&.square{&.selected div{background:var(--primary-color);border-color:var(--primary-color);color:var(--btn-text);}&:not(.selected) div{background:var(--scale-square);border:1px solid var(--ant-entity-border);color:var(--text-color);&:hover{border-radius:2px;border:solid 1px var(--primary-color);background-color:rgba(49,94,251,0.09);}}}}");
var Labels = /*#__PURE__*/styled("div", {
  target: "e1pdnymx2"
})(".labelPoint{width:4px;height:4px;border-radius:50%;background-color:var(--text-color);}");
var NpsSquare = /*#__PURE__*/styled("div", {
  target: "e1pdnymx3"
})("display:flex;justify-content:space-evenly;.number{display:inline-block;margin-right:2px;", function (props) {
  return props.device === 'mobile' ? "&:not(.selected) {\n            opacity: 0.3;\n          }" : "&:hover {\n            opacity: 1;\n          }";
}, " &,&:focus{opacity:0.4;}&.selected{opacity:1;}&:last-child{margin-right:0;}.number-tips{height:", function (props) {
  return props.device === 'mobile' ? 20 : 40;
}, "px;}.nps-item{height:", function (props) {
  return props.device === 'mobile' ? 47 : 55;
}, "px;width:calc((100vw - 65px) / 11);max-width:55px;display:flex;justify-content:center;align-items:center;border-radius:2px;color:#fff;text-align:center;font-size:15px;margin-bottom:3px;cursor:pointer;box-sizing:border-box;}&:nth-of-type(1) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgba(248,213,213,1) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(2) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgba(248,213,213) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(3) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgba(248,213,213) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(4) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgba(248,213,213) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(5) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgb(248,213,213) 0%,rgb(255,255,255,0) 100% );}&:nth-of-type(6) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgba(248,213,213) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(7) .number-tips{border-top:1px solid rgb(225,124,120);background-image:linear-gradient( to bottom,rgba(248,213,213) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(8) .number-tips{border-top:1px solid rgb(247,196,108);background-image:linear-gradient( to bottom,rgba(252,232,196) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(9) .number-tips{border-top:1px solid rgb(247,196,108);background-image:linear-gradient( to bottom,rgba(252,232,196) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(10) .number-tips{border-top:1px solid rgb(148,185,108);background-image:linear-gradient( to bottom,rgba(214,227,197) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(11) .number-tips{border-top:1px solid rgb(148,185,108);background-image:linear-gradient( to bottom,rgba(214,227,197) 0%,rgba(255,255,255,0) 100% );}&:nth-of-type(1) .nps-item{background-image:linear-gradient( 141deg,rgb(222,111,107) 0%,rgb(222,115,112) 75% );}&:nth-of-type(2) .nps-item{background-image:linear-gradient( 141deg,rgb(222,111,107) 0%,rgb(222,115,112) 75% );}&:nth-of-type(3) .nps-item{background-image:linear-gradient( 141deg,rgb(222,111,107) 0%,rgb(222,115,112) 75% );}&:nth-of-type(4) .nps-item{background-image:linear-gradient( 141deg,rgb(222,111,108) 0%,rgb(222,115,112) 75% );}&:nth-of-type(5) .nps-item{background-image:linear-gradient( 141deg,rgb(222,111,108) 0%,rgb(222,115,112) 75% );}&:nth-of-type(6) .nps-item{background-image:linear-gradient( to right,rgb(224,115,107) 0%,rgb(226,121,106) 30%,rgb(230,137,101) 75% );}&:nth-of-type(7) .nps-item{background-image:linear-gradient( to right,rgb(230,137,101) 0%,rgb(230,135,99) 30%,rgb(239,166,97) 95% );}&:nth-of-type(8) .nps-item{background-image:linear-gradient( to right,rgb(240,173,96) 0%,rgb(243,182,95) 40%,rgb(241,187,93) 75% );}&:nth-of-type(9) .nps-item{background-image:linear-gradient( to right,rgb(241,187,93) 0%,rgb(243,182,95) 40%,rgb(219,186,96) 98% );}&:nth-of-type(10) .nps-item{background-image:linear-gradient( to right,rgb(219,186,96) 0%,rgb(204,186,96) 40%,rgb(184,184,95) 75% );}&:nth-of-type(11) .nps-item{margin-right:0 !important;background-image:linear-gradient( to right,rgb(162,181,95) 0%,rgb(149,180,94) 40%,rgb(138,179,95) 75% );}}");
var emojiRateCls = /*#__PURE__*/css(".emoji-rate-faces{display:flex;justify-content:space-around;.emoji-rate-face{width:32px;position:relative;display:flex;align-items:center;}img{cursor:pointer;}}");